import { EImportSectionsTarget } from '@constants';
import { Empty, Flex } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Wrapper,
  TitleWrapper,
  DescriptionWrapper,
  EmojiWrapper
} from './SectionsAndIntroductionEmptyPage.styles';

import { AddSection, ImportSection } from '@/components/SectionManagement';
import { useCourseDetail, useProfile } from '@/store';

type Props = {
  fetchOnlyParentsCourses?: boolean;
  target: EImportSectionsTarget;
};

export const SectionsAndIntroductionEmptyPage: React.FC<Props> = ({
  fetchOnlyParentsCourses,
  target
}) => {
  const { course } = useCourseDetail();
  const { t } = useTranslation('CourseTranslations');
  const {
    roleCheck: { isManager }
  } = useProfile();

  if (!course) return null;

  return (
    <Wrapper>
      {isManager ? (
        <>
          <EmojiWrapper>
            <span role="img" aria-label="folder">
              📚
            </span>
          </EmojiWrapper>

          <Flex vertical gap={8} align="center" justify="center">
            <TitleWrapper>{t('START_BUILDING_YOUR_CONTENT')}</TitleWrapper>
            <DescriptionWrapper>{t('START_BUILDING_YOUR_CONTENT_DESCRIPTION')}</DescriptionWrapper>
          </Flex>

          <Flex gap={16}>
            <AddSection course={course} target={target} />
            <ImportSection target={target} fetchOnlyParentsCourses={fetchOnlyParentsCourses} />
          </Flex>
        </>
      ) : (
        <Empty description={t('COURSE_WITH_NO_SECTIONS')} />
      )}
    </Wrapper>
  );
};
